module.exports = "<input class=\"js-date-input input input_date\" type=text placeholder=\"\">";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/dateTime/templates/dateInput.hbs
// module id = 657
// module chunks = 0